<script setup>
import {blogTitles} from '~/utils/blogUtils'
import {useArticleApi} from '~/composables/api/useArticleApi'
import {getPageTitle} from '~/utils/seoUtils'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import Button from '~/components/common/Button.vue'
import YTPlayer from '~/components/players/YTPlayer.vue'

const route = useRoute()
const config = useRuntimeConfig()
const blogSlug = route.params.blogSlug
const articleSlug = route.params.articleSlug
const currentBlogTitle = computed(() => blogTitles[blogSlug])
const backLink = computed(() => `/blog/${blogSlug}`)

const {data, error} = await useAsyncData(`article-details-${articleSlug}`, async () => {
  try {
    const articleApi = useArticleApi()
    const article = await articleApi.getBySlug(articleSlug)

    return {
      article,
      breadcrumbs: [
        {label: config.public.pageTitle, link: '/'},
        {label: currentBlogTitle, link: `/blog/${blogSlug}`},
        {label: article.title, link: `/blog/${blogSlug}/${articleSlug}`}
      ]
    }
  } catch (e) {
    throw createError({statusCode: 404, message: 'Página no encontrada'})
  }
})

if (!data.value || error.value) {
  throw createError({statusCode: 404, statusMessage: 'page_not_found', fatal: true})
}

useCustomSEOData({
  title: data.value.article.title,
  meta: [
    {name: 'description', content: data.value.article.excerpt},
    {property: 'og:type', content: 'article'},
    {property: 'og:title', content: getPageTitle(data.value.article.title, config.public.pageTitle)},
    {
      hid: 'keywords',
      name: 'keywords',
      content: data.value.article.tags.map((tag) => {
        return tag.title
      }).join(',')
    },
    {property: 'og:description', content: data.value.article.excerpt},
    {hid: 'og:image', name: 'og:image', content: data.value.article.image},
  ]
})
</script>

<template>
  <div class="grid grid-cols-12 blog-style mb-10">
    <div class="col-span-12 offset lg:col-span-8 lg:col-start-2 px-6 xl:px-8 my-3">
      <BreadCrumb :items="data.breadcrumbs"/>
    </div>
    <div class="col-span-12 xl:col-span-10 xl:col-start-2 text-justify mb-5 px-4">
      <h1 class="text-4xl xl:text-8xl font-bold italic px-4 xl:px-8 mb-3">{{ data.article.title }}</h1>
      <!--<div class="mt-5 flex justify-between px-4 xl:px-8">

        <div class="flex my-2">
          <img class="h-[20px] rounded-full mr-1" src="/images/logo-mobile.png" alt="frontend base"/>
          <p class="ml-1 text-xs">{{ data.article.author.name }}</p>
        </div>
        <div class="text-xs italic">
          {{ dateFormat(data.article.publishedAt, 'DD MMMM YYYY') }}
        </div>
      </div> -->
      <img class="w-full my-8 px-4 xl:px-8" :src="data.article.image" :alt="data.article.title" loading="lazy"/>
      <div class="text-md text-justify italic px-4 xl:px-8 mt-5" v-html="data.article.description"></div>
      <template v-if="data.article.video !== ''">
        <YTPlayer :video-id="data.article.video" class="my-12 bg-[#dcd6ce] p-3"/>
      </template>
    </div>

    <div class="col-span-12 flex justify-center px-4 xl:px-8 mb-12">
      <Button
        severity="tertiary"
        label="Listado de Artículos"
        :to="backLink"
      />
    </div>
  </div>
</template>
